<template>
    <div class="customFormWrapper">
        <el-form v-for="(item, index) in collList" :key="index" label-width="200px"
                 style="display: flex;flex-wrap: wrap;justify-content: space-between">
            <el-divider v-if="index != 0"></el-divider>
            <el-form-item :label="cellItem.title+''"
                          v-for="(cellItem,i) in item"
                          v-if="cellItem.showInList"
                          :key="i"
                          :class="{'single-row':cellItem.columnCount == '1' || cellItem.columnType  == '3' }">
                <template slot="label" v-if="cellItem.textType === 1">
                    <span style="display:inline-block;width:174px">{{ cellItem.title }}</span>
                    <span style="display:inline-block;vertical-align: top;">：</span>
                </template>
                <div v-if="cellItem.columnType=='2'">
                    <warn-record-item :key="randerTimeKey()"
                                      :data="cellItem"
                                      :form-info="formInfo"
                    />
                </div>
                <custom-sub-item :key="randerTimeKey()" v-else-if="cellItem.columnType=='4'" :parent-id="cellItem.value"
                                 :param-map="paramMap" :config="parseSource(cellItem.datasource,{'toChild':toChild})"/>
                <dialog-open-btn-item :key="randerTimeKey()" v-else-if="cellItem.columnType=='1'"
                                      :parent-id="cellItem.value" :param-map="paramMap"
                                      :config="parseSource(cellItem.datasource,{'toChild':toChild})"/>
                <span v-else :style="cellItem.style">{{ cellItem.value }}</span>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import warnRecordItem from "./WarnRecordItem";
import dialogOpenBtnItem from "./DialogOpenBtnItem";
import {parseSource, randerTimeKey} from "../../utils/utils";
import customSubItem from "./CustomSubItem";

export default {
    name: "CollListItem",
    components: {
        warnRecordItem,
        dialogOpenBtnItem,
        customSubItem,
    },
    props: {
        collList: {
            type: Array,
            default: []
        },
        paramMap: {
            type: Object,
            required: true
        },
        toChild: {
            type: Boolean,
            defalut: false
        },
        formInfo: {
            type: Object,
            default: () => {
            }
        },
    },
    data() {
        return {
            randerTimeKey: randerTimeKey,
            parseSource: parseSource,
        }
    },
}
</script>

<style lang="less" scoped>
@import "../../css/index.scss";
</style>
